import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachDuDieuKienThucTapActionsObj } from "../../action-types/xet-thuc-tap/IDanhSachDuDieuKienThucTapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachDuDieuKienThucTapActions = {
    ...generateActions(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP"),
    ...generateActionForKey(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP", "LOAD_BY_DOT_THUC_TAP_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP", "LOAD_BY_DOT_THUC_TAP_CHI_TIET_DIEM_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP", "CHUYEN_KHONG_DU_DIEU_KIEN_SUCCESS", () => {
        NotifyHelper.Success("Đã chuyển sinh viên sang không đủ điều kiện thực tập");
    }),
    ...generateActionForKey(eDanhSachDuDieuKienThucTapActionsObj, "DANH_SACH_DU_DIEU_KIEN_THUC_TAP", "CHUYEN_KHONG_DU_DIEU_KIEN_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
}